module.exports = __webpack_public_path__ + "img/pen-02.a5f1598b.png";